export const ADDRESS = {
  AU: {
    TEXT: 'Suite 302, 13/15 Wentworth ave, Sydney NSW 2000, Australia',
    COORDS: '-33.8775178,151.2088058',
    // Structured parts for schema.org PostalAddress
    STREET: 'Suite 302, 13/15 Wentworth Ave',
    LOCALITY: 'Sydney',
    REGION: 'NSW',
    POSTAL_CODE: '2000',
    COUNTRY: 'AU',
  },
}

export const CONTACT_EMAIL = 'info@startupcraft.io'

export const CONTACT_PHONE = '+61 412 428 803'

// tel: href wants the same number without separators.
export const CONTACT_PHONE_HREF = CONTACT_PHONE.replace(/\s/g, '')
